import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Search as SearchInput } from 'UI/Inputs';
import { searchUsers } from 'actions/search';
import { DataList } from 'UI';
import { Checkbox, Button } from '@haldor/ui';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';

var UpdateMeetingInstance = /*#__PURE__*/function (_Component) {
  _inherits(UpdateMeetingInstance, _Component);

  var _super = _createSuper(UpdateMeetingInstance);

  function UpdateMeetingInstance(props) {
    var _this;

    _classCallCheck(this, UpdateMeetingInstance);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        values.staff = _this.state.selectedUsers;

        if (_this.props.onSubmit) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "runSearch", function (term) {
      _this.setState({
        loading: true
      });

      var studentIds = _this.props.meetingInstance.participants.filter(function (x) {
        return x.userType === 'STUDENT';
      }).map(function (x) {
        return x.userID;
      });

      if (term != null && term !== '') {
        _this.setState({
          term: term
        });

        Promise.all([_this.props.searchUsers(term, studentIds)]).then(function () {
          _this.setState({
            loading: false,
            selectStudent: null
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      _this.runSearch(value.query);
    });

    _defineProperty(_assertThisInitialized(_this), "selectUser", function (staff) {
      if (_this.state.selectedUsers.findIndex(function (ss) {
        return ss.userId == staff.userId;
      }) > -1) {
        _this.setState({
          selectedUsers: _this.state.selectedUsers.filter(function (t) {
            return t.userId != staff.userId;
          })
        });
      } else {
        _this.setState({
          selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers), [staff])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderUserName", function (user) {
      if (!user.displayName || user.displayName === " ") return user.email;
      return user.displayName;
    });

    _defineProperty(_assertThisInitialized(_this), "renderResult", function (user) {
      if (_this.props.meetingInstance.participants.find(function (t) {
        return t.userID == user.userId;
      }) != null) return null;
      return /*#__PURE__*/React.createElement(RowItem, {
        key: user.userId
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: _this.state.selectedUsers.find(function (t) {
          return t.userId == user.userId;
        }) != null,
        onChange: function onChange() {
          return _this.selectUser(user);
        },
        label: _this.renderUserName(user) //disabled={this.state.selectedStaff.find(t => t.userId == user.userId) != null}

      }), user.userType == 'GUARDIAN' ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.55rem'
        },
        className: "size-12 color--meta"
      }, _this.props.translate('Guardian')) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "checkDates", function () {
      if (_this.state.date != null && _this.state.endDate != null) {
        if (_this.state.date > _this.state.endDate) {
          return true;
        }
      }

      return false;
    });

    _this.state = {
      selectedUsers: [],
      loading: false
    };
    return _this;
  }

  _createClass(UpdateMeetingInstance, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, this.state.loading ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, this.props.translate('invite-participants')), /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: this.props.translate('search'),
        onSubmit: this.onSearch,
        autofocus: true,
        lengthLimit: 3
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('participants'),
        data: this.props.searchResult,
        renderRow: this.renderResult,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit",
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread({}, values));
        }),
        disabled: submitting || !valid || this.checkDates()
      }, this.props.translate('save')))));
    }
  }]);

  return UpdateMeetingInstance;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    initialValues: state.Meetings.meetingInstance,
    searchResult: state.Search.userSearch
  };
}

export default connect(mapStateToProps, {
  searchUsers: searchUsers
})(reduxForm({
  form: 'UpdateMeetingInstance',
  destroyOnUnmount: true
})(UpdateMeetingInstance));